import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import TheHeader from "./components/TheHeader";
import TheFooter from "./components/TheFooter";
import titleMixin from "./mixins/titleMixin";
import infiniteScroll from "vue-infinite-scroll";
import VueTheMask from "vue-the-mask";
import Vuelidate from "vuelidate";

const NEXT_MATCH_API = "https://api-football-v1.p.rapidapi.com/v3/fixtures";

const RAPID_API_KEY = "5caa97f7dbmsh686b6ad0475fbd8p1b8ee2jsnef9dc411921e";
const RAPID_API_HOST = "api-football-v1.p.rapidapi.com";

Vue.config.productionTip = false;

Vue.component("TheHeader", TheHeader);
Vue.component("TheFooter", TheFooter);

Vue.mixin(titleMixin);
Vue.use(infiniteScroll);
Vue.use(VueTheMask);
Vue.use(Vuelidate);

Vue.prototype.$http = axios.create({
  baseURL: "https://api.cdt.casadebraganca.com/",
});

Vue.prototype.$api = axios.create({
  baseURL:
    "https://cartaodetodosvasco.com.br/api/index.php/wp-json/acf/v3/",
});

Vue.prototype.$matchapi = axios.create({
  baseURL: NEXT_MATCH_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json;charset=UTF-8",
    "X-RapidAPI-Key": RAPID_API_KEY,
    "X-RapidAPI-Host": RAPID_API_HOST
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
